import { NavigateToOptions } from '#app/composables/router'
import type { RouteLocationRaw } from '#vue-router'

export default async (to: RouteLocationRaw | undefined | null, options: NavigateToOptions = {}) => {
    if (typeof to === 'string' && to.startsWith('http')) {
        options.external = true
    }

    return await navigateTo(to, options)
}
